'use client';
import { motion } from 'framer-motion';
import image from '../../Assets/LOGISTICA_BINDTRACK_1.png';
import * as S from './Operation.style';

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const item = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0 },
};

export const Operation = () => {
  const steps = [
    {
      title: 'Agendamento:',
      desc: 'Gestão automática com integração corporativa.',
    },
    {
      title: 'Pátio de espera:',
      desc: 'Organização de veículos com dados centralizados.',
    },
    {
      title: 'Portaria:',
      desc: 'Controle de acesso e tempos de espera.',
    },
    {
      title: 'Balança:',
      desc: 'Integração com ERP para pesagem precisa.',
    },
    {
      title: 'Operação:',
      desc: 'Monitoramento de tempos de carga/descarga.',
    },
    {
      title: 'Pesagem final:',
      desc: 'Dados automáticos no sistema.',
    },
    {
      title: 'Saída:',
      desc: 'Finalização eficiente com devolução de tags.',
    },
  ];

  return (
    <S.Wrapper id="Operation">
      <S.Image src={image} alt="mockup" />

      <motion.div
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.2 }}
        className="mt-10 md:mt-0"
      >
        <S.Title>
          COMO FUNCIONA
        </S.Title>

        <S.SubText>
          Seu fluxo logístico otimizado em <span className="font-bold">7 etapas</span>
        </S.SubText>

        <S.Text
          as={motion.ol}
        >
          {steps.map((step, index) => (
            <motion.li key={index} variants={item}>
              <span className="font-bold">{step.title} </span>
              {step.desc}
            </motion.li>
          ))}
        </S.Text>
      </motion.div>
    </S.Wrapper>
  );
};
